// src/api/api.js
import axios from 'axios';
import { isMobileAppPath } from '../utils/mobileFlowTempStorage';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL, // Fallback si no está definida
});

// Interceptor para incluir el token
// Solo en rutas /m/* se usa el JWT de autogestión (temp_authToken). En el resto, solo el vendedor.
// Si no, un temp_authToken viejo del flujo móvil pisa el authToken nuevo y el API devuelve 401.
api.interceptors.request.use((config) => {
  const tempToken = localStorage.getItem('temp_authToken');
  const regularToken = localStorage.getItem('authToken');
  const token = isMobileAppPath() ? (tempToken || regularToken) : regularToken;

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Interceptor para manejar errores de autenticación
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Verificamos si estamos en la versión mobile
      if (window.location.pathname.startsWith('/m/')) {
        // Redirigimos a la página de error mobile con el tipo correspondiente
        const errorType = error.response?.data?.message?.includes('expired') 
          ? 'token_expired' 
          : 'invalid_token';
        window.location.href = `/m/error/${errorType}`;
      } else {
        // Comportamiento normal para versión desktop
        localStorage.removeItem('authToken');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
